import { Text } from '../../atoms';
import classes from 'classnames';
import LoadingLottieIcon from './loading-lottie-animation.json';
import Lottie from 'react-lottie-light';
import React from 'react';
import styles from './Loading.module.scss';

type Props = {
  title?: string;
  text?: string;
};

export default function Loading({ title, text }: Props) {
  return (
    <div className={classes(styles.wrapper)}>
      <div className={classes(styles.loading)} data-test="css-Spinner">
        <Lottie options={{ animationData: LoadingLottieIcon }} />
      </div>
      {title && (
        <h1
          className={classes(styles.title)}
          data-test="css-Request-Loading-Title"
        >
          {title}
        </h1>
      )}
      {text && (
        <Text
          className={classes(styles.text)}
          text={text}
          kind="p"
          data-test="css-Info"
        />
      )}
    </div>
  );
}
